import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const EDocumentsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .backgroundBox {
    width: 100vw;
    position: absolute;
    height: 10px;
    top: 0;
    left: -16px;
    background: var(--GrayScale-100);
  }
  .housingFundsSection {
    padding: 34px 0px 24px 0px;
    position: relative;
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  .infoOutlineBox {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    border-radius: 16px;
    border: 1px solid var(--GrayScale-400);
    background: var(--GrayScale-0);
    .circle {
      display: none;
    }
  }

  .disabled {
    border: 1px solid var(--GrayScale-400);
    background: var(--GrayScale-100);

    * {
      color: var(--GrayScale-600);
    }
  }

  .selected {
    border: 1px solid var(--Primary-500);
    background: var(--Primary-50);
    .circle {
      display: block;
    }
  }

  //국세청연동
  .step1InfoContainer {
    padding: 34px 0px 24px 0px;
    position: relative;
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  .stepButtonContainer {
    width: 100%;
    position: absolute;
    padding: 8px 16px;
    bottom: 0;
    left: 0;
    background: var(--GrayScale-0);
  }

  .step4InfoContainer {
    position: relative;
    margin-top: 16px;
  }

  .listButtonContainer {
    overflow: auto;
  }

  .listButton {
    width: max-content;
    gap: 8px;
    padding-bottom: 24px;
  }

  //pdf 파일업로드
  .uploadPdfContainer {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .uploadNotAllFile {
    display: flex;
    justify-content: center;
    padding: 6px 24px;
    background: var(--Warning-100);
    border-radius: 16px;
    position: relative;
    width: fit-content;
    margin: 0 auto;
    gap : 10px;
    margin-bottom : 10px;
    /* 말풍선 꼬리 부분 */
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -6px;
      width: 12px;
      height: 12px;
      background: var(--Warning-100);
      transform: translateX(-50%) rotate(45deg);
    }
  }
    

  .uploadFileBoxContainer {
    display: flex;
    padding: 16px;
    flex-direction: column;
    gap: 16px;
    border-radius: 16px;
    border: 1px solid var(--GrayScale-400);
  }

  .uploadFileBox {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .uploadFileTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .monthSection {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .monthBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .month {
    display: flex;
    width: 49px;
    height: 50px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    background: #e2f4ff;
    color: #007aff;
    font-weight: bold;
    font-size: 16px;
  }

  .notWork {
    background: var(--GrayScale-0);
    color: var(--GrayScale-900);
    border: 1px solid var(--GrayScale-400);
  }

  .monthText {
    color: #99caff;
  }

  /* 페이지네이션 스타일 추가 */
  .pagination {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .dot {
    height: 8px;
    width: 8px;
    background-color: #ddd;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .dot.active {
    background-color: #bdb4fe;
  }

  // 국세청 PDF반영내역 테이블
  .yearendManualContentsBox {
    padding: 20px 0px 40px 0px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ntsResultBox {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .tableTr {
    display: flex;
    align-items: stretch;
    width: 100%;
  }

  .tableTitle {
    border: 1px solid #d9d9d9;
    // border-top: none;
    border-right: none;
    background: rgb(245, 245, 245);
    padding: 5px;
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: keep-all;
    min-width: 0;
  }

  .tableBody {
    border: 1px solid #d9d9d9;
    padding: 5px;
    border-top: none;
    flex: 1;
    min-width: 0;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
    // word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tableTitle:first-child {
    border-right: none;
  }

  .tableBody:first-child {
    border-right: none;
    text-align: center;
  }

  .tableTitle:last-child {
    border-right: 1px solid #d9d9d9;
  }

  .tableBody:last-child {
    border-right: 1px solid #d9d9d9;
  }

=
`;
